import { FaLocationDot } from "react-icons/fa6";

export const value = [
  {
    mainaccess: 'Me',
    accessTabs:[
      {id:'access',content:'Me' ,},
    ],
    profile:'/assets/Peacock.jpg',
    avatar: '/assets/two members.png',
    size: '100kb',
    sizeTabs:[
      {id:'100kb',content:'100kb' ,},
    ],
    avatar1:  '/assets/two members.png',
  },
  
  {
    mainaccess: 'swetha',
     accessTabs:[
      {id:'access',content:'Main Access' ,},
    ],
    profile:'/assets/Peacock.jpg',
    avatar: '/assets/two members.png',
    size: '100kb',
    sizeTabs:[
      {id:'100kb',content:'100kb' ,},
    ],
    avatar1: '/assets/two members.png',
  },
  {
    mainaccess: 'priya',
     accessTabs:[
      {id:'access',content:'Main Access' ,},
    ],
    profile:'/assets/Peacock.jpg',
    avatar: '/assets/two members.png',
    size: '100kb',
    sizeTabs:[
      {id:'100kb',content:'100kb' ,},
    ],
    avatar1: '/assets/two members.png',
  },
   {
    mainaccess: 'Sathish',
      accessTabs:[
      {id:'access',content:'Main Access' ,},
    ],
    profile:'/assets/Peacock.jpg',
    avatar: '/assets/two members.png',
     size: '100kb',
    sizeTabs:[
      {id:'100kb',content:'100kb' ,},
    ],
    avatar1: '/assets/two members.png',
  },
   {
    mainaccess: 'Dhanush',
     accessTabs:[
      {id:'access',content:'Main Access' ,},
    ],
    profile:'/assets/Peacock.jpg',
    avatar: '/assets/two members.png',
    size: '100kb',
    sizeTabs:[
      {id:'100kb',content:'100kb' ,},
    ],
    avatar1: '/assets/two members.png',
  }
];

